import React from 'react';
import { Page } from './page';

import Player from '../functions/player';

import { EntitiesArray } from '../components/island';
import { GameInfo } from '../components/gameInfo';
import { Earning } from '../components/earning';
import { Restore } from '../components/restore';

export class Income extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      partOfGame: 5,
      timerOver: false,
    }
  }

  componentWillMount() {
    var currentLocation = this.props.location.pathname;
    Player.storeData('localRoute', currentLocation);

    const newPart = Player.getData('partOfGame');

    this.setState({
      partOfGame: newPart,
    });
  }

  renderEarnings(){
    var earnings = [];
    for (var i = 0; i < EntitiesArray.length; i++) {
      earnings.push(<Earning key={'key_' + i } dataKey={i} data={EntitiesArray[i]} /> )
    }
    return earnings;
  }

  nextRound = () => {
    this.refs.GameInfo.nextRound();
    return;
  }

  render(){
    let elements = this.renderEarnings();
    return(
      <Page pageTitle="Inkomsten" imageSet="2">
      <Restore />

      <div className="col">
        <h2>Inkomsten voor de volgende ronde:</h2>
      </div>
      <div className="col">
      </div>
      <div className="col">
        { elements[0] }
        { elements[2] }
      </div>
      <div className="col">
        { elements[1] }
        { elements[3] }
        <div className="income-info gameInfo-Timeonly" style={{marginTop: "30px"}}>
          <GameInfo ref="GameInfo" part={this.state.partOfGame} getGameScreen={() => {return this.props.location.pathname}} />
          <button className="bigButton" onClick={this.nextRound}>Volgende</button>
        </div>
        </div>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/income.js